/**
 * GET /api/trainer/clients returns a FLAT array of client objects.
 *
 * Seven call sites treated it as a list of groups — `clients.flatMap(g => g.clients || [])` —
 * which yields [] for every element, because a client object has no `.clients` key.
 * The consequences were all silent: subscription and payment rows showed the literal
 * word "Klient" instead of a name, group cards showed a member count with no members,
 * and three client pickers (new group, share a file, assign a package) rendered an
 * empty dropdown — so a trainer with 18 clients could not assign a package to any of
 * them.
 *
 * The grouping seen in the Clients tab is built in the UI, not returned by the API.
 */

/** All clients as a flat array, whatever shape the caller was handed. */
export function flatClients(clients) {
  if (!Array.isArray(clients)) return [];
  // Tolerate a grouped shape too: this list has been read both ways in the past,
  // and a wrong guess here fails silently rather than loudly.
  return clients.flatMap((c) => (Array.isArray(c?.clients) ? c.clients : [c]));
}

/** One client by id, or undefined. */
export function findClient(clients, id) {
  return flatClients(clients).find((c) => c?.id === id);
}
